import { EOT_SQUARE_METERS_MIN_LIMIT } from "@config/consts";
import { ROUTES } from "@config/app.routing";

import { CALENDAR_WEEK_SHIFT } from "@typings/booking";

import { generateReturnUrl } from "@services/ProvidePaymentUrls";

import { IStore } from "@app/redux/reducers";

import {
  getClientRegistrationForm,
  getServiceLocationId,
  getExecutionDate,
  getSelectedTasksList,
  getRequestDifferentStartingHour,
  getSkipAgentAssignment,
  getSquareMeters,
  getWarranty,
  getWeekStartDate,
  getVoucher,
  getSpecialInstructions,
  getSelectedPaymentMethod,
  getLocationUuid,
  getWeekStartDateV2,
} from "./endOfTenancy.selectors";
import {
  END_OF_TENANCY_EXTRA_SERVICES,
  END_OF_TENANCY_EXTRA_SERVICES_LEGACY,
} from "./endOfTenancy.typings";

export const getClientRegistrationEndpointRequest = (store: IStore) => {
  const form = getClientRegistrationForm(store);

  return {
    email: form.get("email"),
    password: form.get("password"),
    firstName: form.get("firstName"),
    lastName: form.get("lastName"),
    phoneNumber: form.get("phoneNumber"),
    mainLocation: {
      serviceLocationId: getServiceLocationId(store),
      address: form.get("address"),
      floorAndDoor: form.get("floorAndDoor"),
      entryCode: form.get("entryCode"),
    },
    marketingConsent: form.get("marketingConsent"),
  };
};

export const getAddLocationEndpointRequest = (store: IStore) => {
  const form = getClientRegistrationForm(store);

  return {
    serviceLocationId: getServiceLocationId(store),
    address: form.get("address"),
    floorAndDoor: form.get("floorAndDoor"),
    entryCode: form.get("entryCode"),
  };
};

export const getReservationEndpointRequest = (store: IStore) => {
  const tasks = getSelectedTasksList(store).map(item => ({
    //@ToDo: remove this condition once backend fixes extra services enum
    service:
      item.get("service") === END_OF_TENANCY_EXTRA_SERVICES.INSIDE_OVEN
        ? END_OF_TENANCY_EXTRA_SERVICES_LEGACY.INSIDE_OWEN
        : item.get("service"),
  }));

  return {
    serviceLocationId: getServiceLocationId(store),
    executionDate: getExecutionDate(store),
    warranty: getWarranty(store),
    squareMeters: getSquareMeters(store),
    requestDifferentStartingHour: getRequestDifferentStartingHour(store),
    skipAgentAssignment: getSkipAgentAssignment(store),
    tasks,
  };
};

export const getAvailabilityEndpointRequest = (
  store: IStore,
  weekShift?: CALENDAR_WEEK_SHIFT,
) => {
  const tasks = getSelectedTasksList(store).map(item => ({
    //@ToDo: remove this condition once backend fixes extra services enum
    service:
      item.get("service") === END_OF_TENANCY_EXTRA_SERVICES.INSIDE_OVEN
        ? END_OF_TENANCY_EXTRA_SERVICES_LEGACY.INSIDE_OWEN
        : item.get("service"),
  }));

  return {
    serviceLocationId: getServiceLocationId(store),
    weekStartDate: weekShift ? getWeekStartDate(store, weekShift) : "",
    tasks,
    squareMeters: getSquareMeters(store) || EOT_SQUARE_METERS_MIN_LIMIT,
  };
};

export const getCustomAvailabilityEndpointRequest = (
  store: IStore,
  customWeekStartDate?: string,
) => {
  const tasks = getSelectedTasksList(store).map(item => ({
    //@ToDo: remove this condition once backend fixes extra services enum
    service:
      item.get("service") === END_OF_TENANCY_EXTRA_SERVICES.INSIDE_OVEN
        ? END_OF_TENANCY_EXTRA_SERVICES_LEGACY.INSIDE_OWEN
        : item.get("service"),
  }));

  return {
    tasks,
    serviceLocationId: getServiceLocationId(store),
    squareMeters: getSquareMeters(store) || EOT_SQUARE_METERS_MIN_LIMIT,
    weekStartDate: customWeekStartDate ?? getWeekStartDateV2(store),
  };
};

export const getPricingEndpointRequest = (store: IStore) => {
  const voucherToken = getVoucher(store);
  const tasks = getSelectedTasksList(store).map(item => ({
    //@ToDo: remove this condition once backend fixes extra services enum
    service:
      item.get("service") === END_OF_TENANCY_EXTRA_SERVICES.INSIDE_OVEN
        ? END_OF_TENANCY_EXTRA_SERVICES_LEGACY.INSIDE_OWEN
        : item.get("service"),
  }));

  return {
    serviceLocationId: getServiceLocationId(store),
    tasks,
    executionDate: getExecutionDate(store),
    warranty: getWarranty(store),
    squareMeters: getSquareMeters(store) || EOT_SQUARE_METERS_MIN_LIMIT,
    ...(voucherToken && { voucherToken }),
  };
};

export const getCheckoutEndpointRequest = (store: IStore) => {
  const voucherToken = getVoucher(store);
  const returnUrl = generateReturnUrl({
    originRoute: ROUTES.END_OF_TENANCY_CHECKOUT,
    targetRoute: `${ROUTES.CLIENT_DASHBOARD}${ROUTES.CLIENT_DASHBOARD_MY_CLEANINGS}`,
  });

  return {
    returnUrl,
    specialInstructions: getSpecialInstructions(store),
    paymentMethod: getSelectedPaymentMethod(store),
    locationUuid: getLocationUuid(store),
    ...(voucherToken && { voucherToken }),
  };
};
